import './font/iconfont.js';
import './font2/iconfont.js';


// WEBPACK FOOTER //
// ./src/styles/components/iconfont/index.js